import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  Tooltip,
  Tabs,
  Tab
} from "@mui/material";

import { fetchCustomers } from "../services/Customers/CustomersData";
import CustomerDetailsDialog from "../components/PagesComponents/Customers/CustomerDetailsDialog";

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    const loadCustomers = async () => {
      try {
        const data = await fetchCustomers();
        const formatted = data.map((item) => ({
          id: item.id,
          name: item.name || "بدون اسم",
          phone: item.phone1 || "غير متوفر",
          email: item.email || "غير متوفر",
          orders: 0
        }));
        setCustomers(formatted);
      } catch (error) {
        console.error("❌ فشل في تحميل العملاء:", error.message);
      }
    };
    loadCustomers();
  }, []);

  // العملاء بدون اسم أو العملاء السيستم
  const systemCustomers = customers.filter(
    (customer) =>
      customer.name === "بدون اسم" ||
      customer.name === "DeliveryCustomer" ||
      customer.name === "TakeAwayCustomer" ||
      customer.name === "TablesCustomer"
  );

  // العملاء العاديين
  const namedCustomers = customers.filter(
    (customer) =>
      customer.name !== "بدون اسم" &&
      customer.name !== "DeliveryCustomer" &&
      customer.name !== "TakeAwayCustomer" &&
      customer.name !== "TablesCustomer"
  );

  // اختيار العملاء حسب التاب
  const displayedCustomers =
    tabIndex === 0
      ? namedCustomers.filter((customer) =>
          customer.name.toLowerCase().includes(searchTerm.toLowerCase())
        )
      : systemCustomers.filter((customer) =>
          customer.name.toLowerCase().includes(searchTerm.toLowerCase())
        );

  const handleOpenDetails = (customer) => {
    setSelectedCustomer(customer);
    setDetailsOpen(true);
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4">👤 إدارة العملاء</Typography>

      <Tabs value={tabIndex} onChange={(e, v) => setTabIndex(v)} sx={{ mb: 2 }}>
        <Tab label="كل العملاء" />
        <Tab label="عملاء بدون اسم أو سيستم" />
      </Tabs>

      <TextField
        label="🔍 بحث بالاسم"
        variant="outlined"
        fullWidth
        sx={{ my: 2 }}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <TableContainer component={Paper} sx={{ mt: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>الاسم</TableCell>
              <TableCell>رقم الهاتف</TableCell>
              <TableCell>البريد الإلكتروني</TableCell>
              <TableCell>عدد الطلبات</TableCell>
              <TableCell>إجراء</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedCustomers.map((customer) => (
              <TableRow key={customer.id}>
                <TableCell>
                  <Tooltip title="تفاصيل العميل" arrow>
                    <span style={{ cursor: "pointer" }}>{customer.name}</span>
                  </Tooltip>
                </TableCell>
                <TableCell>{customer.phone}</TableCell>
                <TableCell>{customer.email}</TableCell>
                <TableCell>{customer.orders}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleOpenDetails(customer)}
                  >
                    عرض التفاصيل
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <CustomerDetailsDialog
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        customerDetails={selectedCustomer}
      />
    </Box>
  );
};

export default Customers;
